import { DashboardConstants } from "../constants/dashboard.constants";

const DashboardReducer = (state, action) => {
  switch (action.type) {
    case DashboardConstants.USER_DASHBOARD_COUNT_REQUEST:
      return {
        ...state,
        isUserDashboardLoading: true,
        hasError: false,
      };
    case DashboardConstants.USER_DASHBOARD_COUNT_SUCCESS:
      return {
        ...state,
        isUserDashboardLoading: false,
        dashboadUserCount: action.payload,
      };
    case DashboardConstants.USER_DASHBOARD_COUNT_FAILURE:
      return {
        ...state,
        hasError: true,
        isUserDashboardLoading: false,
      };

    case DashboardConstants.REVENUE_CHART_DATA_REQUEST:
      return {
        ...state,
        isRevenueLoading: true,
      };
    case DashboardConstants.REVENUE_CHART_DATA_SUCCESS:
      return {
        ...state,
        isRevenueLoading: false,
        revenueChartData: action.payload,
      };
    case DashboardConstants.REVENUE_CHART_DATA_FAILURE:
      return {
        ...state,
        isRevenueLoading: false,
      };

    case DashboardConstants.RENEWAL_CHART_DATA_REQUEST:
      return {
        ...state,
        isRenewalLoading: true,
      };
    case DashboardConstants.RENEWAL_CHART_DATA_SUCCESS:
      return {
        ...state,
        isRenewalLoading: false,
        renewalChartData: action.payload,
      };
    case DashboardConstants.RENEWAL_CHART_DATA_FAILURE:
      return {
        ...state,
        isRenewalLoading: false,
      };

    default:
      return state;
  }
};

export default DashboardReducer;
